import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"

export default [
  {
    path: "/dashboard-layout-home",
    component: () => import("@/layouts/dashboard/DashboardLayout.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () => import("@/modules/home/pages/home/HomePage.vue")
      },
      {
        path: "/download-app",
        name: "download-app",
        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
          GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
        },
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/telehealth-terms",
        name: "telehealth-terms",
        component: () => import("@/modules/home/pages/terms/TelehealthTerms.vue")
      },
      // --- Deeplinks on the mobile app ---
      {
        path: "/my-questionnaires",
        name: "my-questionnaires",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/home/schedule-appointment",
        name: "schedule-appointment",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/home/pharmacy-card",
        name: "pharmacy-card",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/my-dependents",
        name: "my-dependents",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/campaign",
        name: "campaign",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/appointments",
        name: "appointments",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      },
      {
        path: "/appointments/:appointmentId",
        name: "appointments-details",
        component: () => import("@/modules/home/pages/download-app/DownloadAppPage.vue")
      }
    ]
  }
]
